import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Основные страницы
import HomePage from '../pages/HomePage';
import CategoryPage from '../pages/CategoryPage';
import NotFoundPage from '../pages/NotFoundPage';
import SearchResults from '../pages/SearchResults';
import AboutPage from '../pages/AboutPage';
import FaqPage from '../pages/FaqPage';
import ContactsPage from '../pages/ContactsPage';
import PrivacyPolicyPage from '../pages/PrivacyPolicyPage';
import TermsOfUsePage from '../pages/TermsOfUsePage';

// Страницы инструментов финансов
import CurrencyConverterPage from '../pages/tools/finance/CurrencyConverterPage';
import MortgageCalculatorPage from '../pages/tools/finance/MortgageCalculatorPage';
import LoanCalculatorPage from '../pages/tools/finance/LoanCalculatorPage';
import VATCalculatorPage from '../pages/tools/finance/VATCalculatorPage';
import DepositCalculatorPage from '../pages/tools/finance/DepositCalculatorPage';
import PercentageConverterPage from '../pages/tools/finance/PercentageConverterPage';
import AdditiveManufacturingCostCalculatorPage from '../pages/tools/finance/AdditiveManufacturingCostCalculatorPage';
import AdvertisingCampaignCostCalculatorPage from '../pages/tools/finance/AdvertisingCampaignCostCalculatorPage';
import AgriculturalSubsidiesCalculatorPage from '../pages/tools/finance/AgriculturalSubsidiesCalculatorPage';
import AiInEducationCostCalculatorPage from '../pages/tools/finance/AiInEducationCostCalculatorPage';
import AiInvestmentCalculatorPage from '../pages/tools/finance/AiInvestmentCalculatorPage';
import ArbitrationCostCalculatorPage from '../pages/tools/finance/ArbitrationCostCalculatorPage';
import ArchitecturalSolutionsCostCalculatorPage from '../pages/tools/finance/ArchitecturalSolutionsCostCalculatorPage';
import ArTechnologiesCostCalculatorPage from '../pages/tools/finance/ArTechnologiesCostCalculatorPage';
import AutoLoanCalculatorPage from '../pages/tools/finance/AutoLoanCalculatorPage';
import BankruptcyRiskCalculatorPage from '../pages/tools/finance/BankruptcyRiskCalculatorPage';
import BigDataProjectCostCalculatorPage from '../pages/tools/finance/BigDataProjectCostCalculatorPage';
import BlockchainProjectCostCalculatorPage from '../pages/tools/finance/BlockchainProjectCostCalculatorPage';
import BusinessProcessTransformationCostCalculatorPage from '../pages/tools/finance/BusinessProcessTransformationCostCalculatorPage';
import DepreciationCalculatorPage from '../pages/tools/finance/DepreciationCalculatorPage';
import ForeignCurrencyMortgageCalculatorPage from '../pages/tools/finance/ForeignCurrencyMortgageCalculatorPage';
import DividendCalculatorPage from '../pages/tools/finance/DividendCalculatorPage';
import LoanEarlyRepaymentCalculatorPage from '../pages/tools/finance/LoanEarlyRepaymentCalculatorPage';
import StockInvestmentCalculatorPage from '../pages/tools/finance/StockInvestmentCalculatorPage';
import InflationCalculatorPage from '../pages/tools/finance/InflationCalculatorPage';
import CryptocurrencyInvestmentCalculatorPage from '../pages/tools/finance/CryptocurrencyInvestmentCalculatorPage';
import LiquidityRatioCalculatorPage from '../pages/tools/finance/LiquidityRatioCalculatorPage';
import EducationSavingsCalculatorPage from '../pages/tools/finance/EducationSavingsCalculatorPage';
import IncomeTaxCalculatorPage from '../pages/tools/finance/IncomeTaxCalculatorPage';
import CorporateIncomeTaxCalculatorPage from '../pages/tools/finance/CorporateIncomeTaxCalculatorPage';
import LuxuryTaxCalculatorPage from '../pages/tools/finance/LuxuryTaxCalculatorPage';
import TaxDeductionCalculatorPage from '../pages/tools/finance/TaxDeductionCalculatorPage';
import SalesTaxCalculatorPage from '../pages/tools/finance/SalesTaxCalculatorPage';
import CarInsuranceCalculatorPage from '../pages/tools/finance/CarInsuranceCalculatorPage';
import PropertyTaxCalculatorPage from '../pages/tools/finance/PropertyTaxCalculatorPage';
import ProfitabilityCalculatorPage from '../pages/tools/finance/ProfitabilityCalculatorPage';
import LoanRefinancingCalculatorPage from '../pages/tools/finance/LoanRefinancingCalculatorPage';
import FreelanceTaxCalculatorPage from '../pages/tools/finance/FreelanceTaxCalculatorPage';
import FamilyBudgetCalculatorPage from '../pages/tools/finance/FamilyBudgetCalculatorPage';
import CompoundInterestCalculatorPage from '../pages/tools/finance/CompoundInterestCalculatorPage';
import FinancialIndependenceCalculatorPage from '../pages/tools/finance/FinancialIndependenceCalculatorPage';
import PensionCalculatorPage from '../pages/tools/finance/PensionCalculatorPage';

// Страницы инструментов здоровья
import BmrCalculatorPage from '../pages/tools/health/BmrCalculatorPage';
import BmiCalculatorPage from '../pages/tools/health/BmiCalculatorPage';
import OvulationCalculatorPage from '../pages/tools/health/OvulationCalculatorPage';
import CalorieNeedsCalculatorPage from '../pages/tools/health/CalorieNeedsCalculatorPage';
import MaxHeartRateCalculatorPage from '../pages/tools/health/MaxHeartRateCalculatorPage';
import BodyFatPercentageCalculatorPage from '../pages/tools/health/BodyFatPercentageCalculatorPage';
import WhRatioCalculatorPage from '../pages/tools/health/WhRatioCalculatorPage';
import TdeeCalculatorPage from '../pages/tools/health/TdeeCalculatorPage';
import WaterIntakeCalculatorPage from '../pages/tools/health/WaterIntakeCalculatorPage';
import TargetHeartRateCalculatorPage from '../pages/tools/health/TargetHeartRateCalculatorPage';

// Страницы инструментов путешествий
import TimezoneConverterPage from '../pages/tools/travel/TimezoneConverterPage';
import TemperatureConverterPage from '../pages/tools/travel/TemperatureConverterPage';
import VisaFeeCalculatorPage from '../pages/tools/travel/VisaFeeCalculatorPage';
import DrivingTimeCalculatorPage from '../pages/tools/travel/DrivingTimeCalculatorPage';
import FlightTimeCalculatorPage from '../pages/tools/travel/FlightTimeCalculatorPage';
import LuggageWeightCalculatorPage from '../pages/tools/travel/LuggageWeightCalculatorPage';
import FuelConsumptionCalculatorPage from '../pages/tools/travel/FuelConsumptionCalculatorPage';
import TripCostCalculatorPage from '../pages/tools/travel/TripCostCalculatorPage';
import PerDiemCalculatorPage from '../pages/tools/travel/PerDiemCalculatorPage';
import DistanceConverterPage from '../pages/tools/travel/DistanceConverterPage';

// Страницы инструментов для дома
import WallpaperRollCalculatorPage from '../pages/tools/home/WallpaperRollCalculatorPage';
import PoolVolumeCalculatorPage from '../pages/tools/home/PoolVolumeCalculatorPage';
import ConcreteVolumeCalculatorPage from '../pages/tools/home/ConcreteVolumeCalculatorPage';
import PaintCoverageCalculatorPage from '../pages/tools/home/PaintCoverageCalculatorPage';
import LightingCalculatorPage from '../pages/tools/home/LightingCalculatorPage';
import RoomAreaCalculatorPage from '../pages/tools/home/RoomAreaCalculatorPage';
import PipeFlowCalculatorPage from '../pages/tools/home/PipeFlowCalculatorPage';
import TileCoverageCalculatorPage from '../pages/tools/home/TileCoverageCalculatorPage';
import ElectricityCostCalculatorPage from '../pages/tools/home/ElectricityCostCalculatorPage';
import HeatLossCalculatorPage from '../pages/tools/home/HeatLossCalculatorPage';

// Страницы инструментов для времени
import ScheduleGeneratorPage from '../pages/tools/time/ScheduleGeneratorPage';
import DayCountCalculatorPage from '../pages/tools/time/DayCountCalculatorPage';
import DateAddSubtractCalculatorPage from '../pages/tools/time/DateAddSubtractCalculatorPage';
import TimeIntervalCalculatorPage from '../pages/tools/time/TimeIntervalCalculatorPage';
import WorkHoursCalculatorPage from '../pages/tools/time/WorkHoursCalculatorPage';
import UnixTimeConverterPage from '../pages/tools/time/UnixTimeConverterPage';
import TimeZoneConverterPage from '../pages/tools/time/TimeZoneConverterPage';
import CountdownTimerPage from '../pages/tools/time/CountdownTimerPage';
import WorldClockPage from '../pages/tools/time/WorldClockPage';

// Страницы генераторов
import BcryptHashGeneratorPage from '../pages/tools/generators/BcryptHashGeneratorPage';
import PasswordGeneratorPage from '../pages/tools/generators/PasswordGeneratorPage';
import MailtoLinkGeneratorPage from '../pages/tools/generators/MailtoLinkGeneratorPage';
import RandomNumberGeneratorPage from '../pages/tools/generators/RandomNumberGeneratorPage';
import TextSizeCalculatorPage from '../pages/tools/generators/TextSizeCalculatorPage';
import UrlRedirectCheckerPage from '../pages/tools/generators/UrlRedirectCheckerPage';
import ExifDataReaderPage from '../pages/tools/generators/ExifDataReaderPage';

// Компонент маршрутизации
const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        {/* Главная страница */}
        <Route path="/" element={<HomePage />} />
        
        {/* Страницы категорий */}
        <Route path="/category/:categoryId" element={<CategoryPage />} />
        
        {/* Страницы финансовых инструментов */}
        <Route path="/tools/finance/currency-converter" element={<CurrencyConverterPage />} />
        <Route path="/tools/finance/currency-converter/:subToolId" element={<CurrencyConverterPage />} />
        
        <Route path="/tools/finance/mortgage-calculator" element={<MortgageCalculatorPage />} />
        <Route path="/tools/finance/mortgage-calculator/:subToolId" element={<MortgageCalculatorPage />} />
        
        <Route path="/tools/finance/loan-calculator" element={<LoanCalculatorPage />} />
        <Route path="/tools/finance/loan-calculator/:subToolId" element={<LoanCalculatorPage />} />
        
        <Route path="/tools/finance/vat-calculator" element={<VATCalculatorPage />} />
        <Route path="/tools/finance/vat-calculator/:subToolId" element={<VATCalculatorPage />} />
        
        <Route path="/tools/finance/deposit-calculator" element={<DepositCalculatorPage />} />
        <Route path="/tools/finance/deposit-calculator/:subToolId" element={<DepositCalculatorPage />} />
        
        <Route path="/tools/finance/percentage-converter" element={<PercentageConverterPage />} />
        <Route path="/tools/finance/percentage-converter/:subToolId" element={<PercentageConverterPage />} />

        <Route path="/tools/finance/additive-manufacturing-calculator" element={<AdditiveManufacturingCostCalculatorPage />} />
        <Route path="/tools/finance/additive-manufacturing-calculator/:subToolId" element={<AdditiveManufacturingCostCalculatorPage />} />

        <Route path="/tools/finance/advertising-calculator" element={<AdvertisingCampaignCostCalculatorPage />} />
        <Route path="/tools/finance/advertising-calculator/:subToolId" element={<AdvertisingCampaignCostCalculatorPage />} />

        <Route path="/tools/finance/agricultural-subsidies-calculator" element={<AgriculturalSubsidiesCalculatorPage />} />
        <Route path="/tools/finance/agricultural-subsidies-calculator/:subToolId" element={<AgriculturalSubsidiesCalculatorPage />} />

        <Route path="/tools/finance/ai-education-cost-calculator" element={<AiInEducationCostCalculatorPage />} />
        <Route path="/tools/finance/ai-education-cost-calculator/:subToolId" element={<AiInEducationCostCalculatorPage />} />
        
        <Route path="/tools/finance/ai-investment-calculator" element={<AiInvestmentCalculatorPage />} />
        <Route path="/tools/finance/ai-investment-calculator/:subToolId" element={<AiInvestmentCalculatorPage />} />

        <Route path="/tools/finance/arbitration-calculator" element={<ArbitrationCostCalculatorPage />} />
        <Route path="/tools/finance/arbitration-calculator/:subToolId" element={<ArbitrationCostCalculatorPage />} />

        <Route path="/tools/finance/architectural-solutions-calculator" element={<ArchitecturalSolutionsCostCalculatorPage />} />
        <Route path="/tools/finance/architectural-solutions-calculator/:subToolId" element={<ArchitecturalSolutionsCostCalculatorPage />} />

        <Route path="/tools/finance/ar-technologies-cost-calculator" element={<ArTechnologiesCostCalculatorPage />} />
        <Route path="/tools/finance/ar-technologies-cost-calculator/:subToolId" element={<ArTechnologiesCostCalculatorPage />} />

        <Route path="/tools/finance/auto-loan-calculator" element={<AutoLoanCalculatorPage />} />
        <Route path="/tools/finance/auto-loan-calculator/:subToolId" element={<AutoLoanCalculatorPage />} />

        <Route path="/tools/finance/bankruptcy-risk-calculator" element={<BankruptcyRiskCalculatorPage />} />
        <Route path="/tools/finance/bankruptcy-risk-calculator/:subToolId" element={<BankruptcyRiskCalculatorPage />} />        
        
        <Route path="/tools/finance/big-data-cost-calculator" element={<BigDataProjectCostCalculatorPage />} />
        <Route path="/tools/finance/big-data-cost-calculator/:subToolId" element={<BigDataProjectCostCalculatorPage />} />   

        <Route path="/tools/finance/blockchain-cost-calculator" element={<BlockchainProjectCostCalculatorPage />} />
        <Route path="/tools/finance/blockchain-cost-calculator/:subToolId" element={<BlockchainProjectCostCalculatorPage />} />

        <Route path="/tools/finance/business-process-transformation-calculator" element={<BusinessProcessTransformationCostCalculatorPage />} />
        <Route path="/tools/finance/business-process-transformation-calculator/:subToolId" element={<BusinessProcessTransformationCostCalculatorPage />} />  

        <Route path="/tools/finance/depreciation-calculator" element={<DepreciationCalculatorPage />} />
        <Route path="/tools/finance/depreciation-calculator/:subToolId" element={<DepreciationCalculatorPage />} />

        <Route path="/tools/finance/foreign-currency-mortgage-calculator" element={<ForeignCurrencyMortgageCalculatorPage />} />
        <Route path="/tools/finance/foreign-currency-mortgage-calculator/:subToolId" element={<ForeignCurrencyMortgageCalculatorPage />} />  

        <Route path="/tools/finance/dividend-calculator" element={<DividendCalculatorPage />} />
        <Route path="/tools/finance/dividend-calculator/:subToolId" element={<DividendCalculatorPage />} />  

        <Route path="/tools/finance/loan-early-repayment-calculator" element={<LoanEarlyRepaymentCalculatorPage />} />
        <Route path="/tools/finance/loan-early-repayment-calculator/:subToolId" element={<LoanEarlyRepaymentCalculatorPage />} />  

        <Route path="/tools/finance/stock-investment-calculator" element={<StockInvestmentCalculatorPage />} />
        <Route path="/tools/finance/stock-investment-calculator/:subToolId" element={<StockInvestmentCalculatorPage />} />  
        
        <Route path="/tools/finance/inflation-calculator" element={<InflationCalculatorPage />} />
        <Route path="/tools/finance/inflation-calculator/:subToolId" element={<InflationCalculatorPage />} />

        <Route path="/tools/finance/cryptocurrency-investment-calculator" element={<CryptocurrencyInvestmentCalculatorPage />} />
        <Route path="/tools/finance/cryptocurrency-investment-calculator/:subToolId" element={<CryptocurrencyInvestmentCalculatorPage />} /> 
        
        <Route path="/tools/finance/liquidity-ratio-calculator" element={<LiquidityRatioCalculatorPage />} />
        <Route path="/tools/finance/liquidity-ratio-calculator/:subToolId" element={<LiquidityRatioCalculatorPage />} /> 

        <Route path="/tools/finance/education-savings-calculator" element={<EducationSavingsCalculatorPage />} />
        <Route path="/tools/finance/education-savings-calculator/:subToolId" element={<EducationSavingsCalculatorPage />} /> 
        
        <Route path="/tools/finance/income-tax-calculator" element={<IncomeTaxCalculatorPage />} />
        <Route path="/tools/finance/income-tax-calculator/:subToolId" element={<IncomeTaxCalculatorPage />} /> 

        <Route path="/tools/finance/corporate-tax-calculator" element={<CorporateIncomeTaxCalculatorPage />} />
        <Route path="/tools/finance/corporate-tax-calculator/:subToolId" element={<CorporateIncomeTaxCalculatorPage />} /> 
        
        <Route path="/tools/finance/luxury-tax-calculator" element={<LuxuryTaxCalculatorPage />} />
        <Route path="/tools/finance/luxury-tax-calculator/:subToolId" element={<LuxuryTaxCalculatorPage />} /> 

        <Route path="/tools/finance/tax-deduction-calculator" element={<TaxDeductionCalculatorPage />} />
        <Route path="/tools/finance/tax-deduction-calculator/:subToolId" element={<TaxDeductionCalculatorPage />} /> 
        
        <Route path="/tools/finance/vat-calculator" element={<SalesTaxCalculatorPage />} />
        <Route path="/tools/finance/vat-calculator/:subToolId" element={<SalesTaxCalculatorPage />} /> 

        <Route path="/tools/finance/car-insurance-calculator" element={<CarInsuranceCalculatorPage />} />
        <Route path="/tools/finance/car-insurance-calculator/:subToolId" element={<CarInsuranceCalculatorPage />} /> 

        <Route path="/tools/finance/property-tax-calculator" element={<PropertyTaxCalculatorPage />} />
        <Route path="/tools/finance/property-tax-calculator/:subToolId" element={<PropertyTaxCalculatorPage />} /> 
        
        <Route path="/tools/finance/profitability-calculator" element={<ProfitabilityCalculatorPage />} />
        <Route path="/tools/finance/profitability-calculator/:subToolId" element={<ProfitabilityCalculatorPage />} /> 
        
        <Route path="/tools/finance/loan-refinancing-calculator" element={<LoanRefinancingCalculatorPage />} />
        <Route path="/tools/finance/loan-refinancing-calculator/:subToolId" element={<LoanRefinancingCalculatorPage />} /> 

        <Route path="/tools/finance/freelance-tax-calculator" element={<FreelanceTaxCalculatorPage />} />
        <Route path="/tools/finance/freelance-tax-calculator/:subToolId" element={<FreelanceTaxCalculatorPage />} /> 

        <Route path="/tools/finance/family-budget-calculator" element={<FamilyBudgetCalculatorPage />} />
        <Route path="/tools/finance/family-budget-calculator/:subToolId" element={<FamilyBudgetCalculatorPage />} />

        <Route path="/tools/finance/compound-interest-calculator" element={<CompoundInterestCalculatorPage />} />
        <Route path="/tools/finance/compound-interest-calculator/:subToolId" element={<CompoundInterestCalculatorPage />} />

        <Route path="/tools/finance/financial-independence-calculator" element={<FinancialIndependenceCalculatorPage />} />
        <Route path="/tools/finance/financial-independence-calculator/:subToolId" element={<FinancialIndependenceCalculatorPage />} />

        <Route path="/tools/finance/pension-calculator" element={<PensionCalculatorPage />} />
        <Route path="/tools/finance/pension-calculator/:subToolId" element={<PensionCalculatorPage />} />
        
        {/* Страницы инструментов здоровья */}
        <Route path="/tools/health/bmr-calculator" element={<BmrCalculatorPage />} />
        <Route path="/tools/health/bmr-calculator/:subToolId" element={<BmrCalculatorPage />} />

        <Route path="/tools/health/bmi-calculator" element={<BmiCalculatorPage />} />
        <Route path="/tools/health/bmi-calculator/:subToolId" element={<BmiCalculatorPage />} />

        <Route path="/tools/health/ovulation-calculator" element={<OvulationCalculatorPage />} />
        <Route path="/tools/health/ovulation-calculator/:subToolId" element={<OvulationCalculatorPage />} />

        <Route path="/tools/health/calorie-needs-calculator" element={<CalorieNeedsCalculatorPage />} />
        <Route path="/tools/health/calorie-needs-calculator/:subToolId" element={<CalorieNeedsCalculatorPage />} />

        <Route path="/tools/health/max-heart-rate-calculator" element={<MaxHeartRateCalculatorPage />} />
        <Route path="/tools/health/max-heart-rate-calculator/:subToolId" element={<MaxHeartRateCalculatorPage />} />

        <Route path="/tools/health/bodyfat-calculator" element={<BodyFatPercentageCalculatorPage />} />
        <Route path="/tools/health/bodyfat-calculator/:subToolId" element={<BodyFatPercentageCalculatorPage />} />

        <Route path="/tools/health/whr-calculator" element={<WhRatioCalculatorPage />} />
        <Route path="/tools/health/whr-calculator/:subToolId" element={<WhRatioCalculatorPage />} />

        <Route path="/tools/health/tdee-calculator" element={<TdeeCalculatorPage />} />
        <Route path="/tools/health/tdee-calculator/:subToolId" element={<TdeeCalculatorPage />} />

        <Route path="/tools/health/water-intake-calculator" element={<WaterIntakeCalculatorPage />} />
        <Route path="/tools/health/water-intake-calculator/:subToolId" element={<WaterIntakeCalculatorPage />} />

        <Route path="/tools/health/heart-rate-calculator" element={<TargetHeartRateCalculatorPage />} />
        <Route path="/tools/health/heart-rate-calculator/:subToolId" element={<TargetHeartRateCalculatorPage />} />
        
        {/* Страницы инструментов путешествий */}
        <Route path="/tools/travel/timezone-converter" element={<TimezoneConverterPage />} />
        <Route path="/tools/travel/timezone-converter/:subToolId" element={<TimezoneConverterPage />} />
        
        <Route path="/tools/travel/temperature-converter" element={<TemperatureConverterPage />} />
        <Route path="/tools/travel/temperature-converter/:subToolId" element={<TemperatureConverterPage />} />

        <Route path="/tools/travel/visa-fee-calculator" element={<VisaFeeCalculatorPage />} />
        <Route path="/tools/travel/visa-fee-calculator/:subToolId" element={<VisaFeeCalculatorPage />} />

        <Route path="/tools/travel/driving-time-calculator" element={<DrivingTimeCalculatorPage />} />
        <Route path="/tools/travel/driving-time-calculator/:subToolId" element={<DrivingTimeCalculatorPage />} />

        <Route path="/tools/travel/flight-time-calculator" element={<FlightTimeCalculatorPage />} />
        <Route path="/tools/travel/flight-time-calculator/:subToolId" element={<FlightTimeCalculatorPage />} />

        <Route path="/tools/travel/luggage-weight-calculator" element={<LuggageWeightCalculatorPage />} />
        <Route path="/tools/travel/luggage-weight-calculator/:subToolId" element={<LuggageWeightCalculatorPage />} />

        <Route path="/tools/travel/fuel-consumption-calculator" element={<FuelConsumptionCalculatorPage />} />
        <Route path="/tools/travel/fuel-consumption-calculator/:subToolId" element={<FuelConsumptionCalculatorPage />} />

        <Route path="/tools/travel/trip-cost-calculator" element={<TripCostCalculatorPage />} />
        <Route path="/tools/travel/trip-cost-calculator/:subToolId" element={<TripCostCalculatorPage />} />

        <Route path="/tools/travel/per-diem-calculator" element={<PerDiemCalculatorPage />} />
        <Route path="/tools/travel/per-diem-calculator/:subToolId" element={<PerDiemCalculatorPage />} />
        
        {/* Страницы инструментов для дома */}
        <Route path="/tools/home/wallpaper-calculator" element={<WallpaperRollCalculatorPage />} />
        <Route path="/tools/home/wallpaper-calculator/:subToolId" element={<WallpaperRollCalculatorPage />} />

        <Route path="/tools/home/pool-volume-calculator" element={<PoolVolumeCalculatorPage />} />
        <Route path="/tools/home/pool-volume-calculator/:subToolId" element={<PoolVolumeCalculatorPage />} />

        <Route path="/tools/home/concrete-calculator" element={<ConcreteVolumeCalculatorPage />} />
        <Route path="/tools/home/concrete-calculator/:subToolId" element={<ConcreteVolumeCalculatorPage />} />

        <Route path="/tools/home/paint-calculator" element={<PaintCoverageCalculatorPage />} />
        <Route path="/tools/home/paint-calculator/:subToolId" element={<PaintCoverageCalculatorPage />} />

        <Route path="/tools/home/lighting-calculator" element={<LightingCalculatorPage />} />
        <Route path="/tools/home/lighting-calculator/:subToolId" element={<LightingCalculatorPage />} />

        <Route path="/tools/home/room-area-calculator" element={<RoomAreaCalculatorPage />} />
        <Route path="/tools/home/room-area-calculator/:subToolId" element={<RoomAreaCalculatorPage />} />

        <Route path="/tools/home/pipe-flow-calculator" element={<PipeFlowCalculatorPage />} />
        <Route path="/tools/home/pipe-flow-calculator/:subToolId" element={<PipeFlowCalculatorPage />} />

        <Route path="/tools/home/tile-calculator" element={<TileCoverageCalculatorPage />} />
        <Route path="/tools/home/tile-calculator/:subToolId" element={<TileCoverageCalculatorPage />} />

        <Route path="/tools/home/electricity-cost-calculator" element={<ElectricityCostCalculatorPage />} />
        <Route path="/tools/home/electricity-cost-calculator/:subToolId" element={<ElectricityCostCalculatorPage />} />

        <Route path="/tools/home/heat-loss-calculator" element={<HeatLossCalculatorPage />} />
        <Route path="/tools/home/heat-loss-calculator/:subToolId" element={<HeatLossCalculatorPage />} />
        
        <Route path="/tools/home/distance-converter" element={<DistanceConverterPage />} />
        <Route path="/tools/home/distance-converter/:subToolId" element={<DistanceConverterPage />} />
        
        {/* Страницы инструментов для времени */}
        <Route path="/tools/time/schedule-generator" element={<ScheduleGeneratorPage />} />
        <Route path="/tools/time/schedule-generator/:subToolId" element={<ScheduleGeneratorPage />} />

        <Route path="/tools/time/date-calculator" element={<DayCountCalculatorPage />} />
        <Route path="/tools/time/date-calculator/:subToolId" element={<DayCountCalculatorPage />} />

        <Route path="/tools/time/event-date-planner" element={<DateAddSubtractCalculatorPage />} />
        <Route path="/tools/time/event-date-planner/:subToolId" element={<DateAddSubtractCalculatorPage />} />

        <Route path="/tools/time/time-interval-calculator" element={<TimeIntervalCalculatorPage />} />
        <Route path="/tools/time/time-interval-calculator/:subToolId" element={<TimeIntervalCalculatorPage />} />

        <Route path="/tools/time/work-hours-calculator" element={<WorkHoursCalculatorPage />} />
        <Route path="/tools/time/work-hours-calculator/:subToolId" element={<WorkHoursCalculatorPage />} />

        <Route path="/tools/time/unix-time-converter" element={<UnixTimeConverterPage />} />
        <Route path="/tools/time/unix-time-converter/:subToolId" element={<UnixTimeConverterPage />} />

        <Route path="/tools/time/timezone-converter" element={<TimeZoneConverterPage />} />
        <Route path="/tools/time/timezone-converter/:subToolId" element={<TimeZoneConverterPage />} />

        <Route path="/tools/time/countdown-timer" element={<CountdownTimerPage />} />
        <Route path="/tools/time/countdown-timer/:subToolId" element={<CountdownTimerPage />} />

        <Route path="/tools/time/timezone-converter" element={<WorldClockPage />} />
        <Route path="/tools/time/timezone-converter/:subToolId" element={<WorldClockPage />} />
        
        {/* Страницы генераторов */}
        <Route path="/tools/generators/bcrypt-hash-generator" element={<BcryptHashGeneratorPage />} />
        <Route path="/tools/generators/bcrypt-hash-generator/:subToolId" element={<BcryptHashGeneratorPage />} />

        <Route path="/tools/generators/password-generator" element={<PasswordGeneratorPage />} />
        <Route path="/tools/generators/password-generator/:subToolId" element={<PasswordGeneratorPage />} />

        <Route path="/tools/generators/mailto-link-generator" element={<MailtoLinkGeneratorPage />} />
        <Route path="/tools/generators/mailto-link-generator/:subToolId" element={<MailtoLinkGeneratorPage />} />

        <Route path="/tools/generators/random-number-generator" element={<RandomNumberGeneratorPage />} />
        <Route path="/tools/generators/random-number-generator/:subToolId" element={<RandomNumberGeneratorPage />} />

        <Route path="/tools/generators/text-size-calculator" element={<TextSizeCalculatorPage />} />
        <Route path="/tools/generators/text-size-calculator/:subToolId" element={<TextSizeCalculatorPage />} />

        <Route path="/tools/generators/url-redirect-checker" element={<UrlRedirectCheckerPage />} />
        <Route path="/tools/generators/url-redirect-checker/:subToolId" element={<UrlRedirectCheckerPage />} />

        <Route path="/tools/generators/exif-data-reader" element={<ExifDataReaderPage />} />
        <Route path="/tools/generators/exif-data-reader/:subToolId" element={<ExifDataReaderPage />} />
        
        {/* Страница "не найдено" */}
        <Route path="*" element={<NotFoundPage />} />
        {/* Страница поиска */}
        <Route path="/search" element={<SearchResults />} />
        {/* О проекте */}
        <Route path="/about" element={<AboutPage />} />
        {/* FAQ */}
        <Route path="/faq" element={<FaqPage />} />
        {/* Контакты */}
        <Route path="/contacts" element={<ContactsPage />} />
        {/* Политика конфиденциальности */}
        <Route path="/privacy" element={<PrivacyPolicyPage  />} />        
        {/* Условия использования */}
        <Route path="/terms" element={<TermsOfUsePage  />} />                     
      </Routes>
    </Router>
  );
};

export default AppRoutes;